module.exports = __webpack_public_path__ + "img/code.62a420ad.png";